 let currentGroup = null;
let selectedTextObj = null;
 let currentAlignmentIndex = 0;
let currentRotationAngle = 0;
 window.active_side = 'back';

// crop custom

let isCropping = false;
let cropRect = null;
let cropStart = null;
let selectedImage = null;


let undoStack = [];
let redoStack = [];
let isRestoring = false;




    const canvas = new fabric.Canvas('customizer-canvas', {
      preserveObjectStacking: true
    });


    canvas.on('object:added', saveState);
    canvas.on('object:modified', saveState);
    canvas.on('object:removed', saveState);








        // const canvasEl = document.getElementById('customizer-canvas');
        // canvasEl.width = window.innerWidth;
        // canvasEl.height = window.innerHeight;
        // canvas.setWidth(canvasEl.width);
        // canvas.setHeight(canvasEl.height);
        // canvas.renderAll();
    // Preload the trash icon for reuse
    const deleteIconImg = document.createElement('img');
    deleteIconImg.src = 'https://cdn-icons-png.flaticon.com/512/1828/1828843.png';

    // Delete control setup
    fabric.Object.prototype.controls.deleteControl = new fabric.Control({
      x: 0.5,
      y: -0.5,
      offsetY: -10,
      offsetX: 10,
      cursorStyle: 'pointer',
      mouseUpHandler: deleteObject,
      render: renderDeleteIcon,
      cornerSize: 24,
      touchCornerSize:150
    });
// fabric.Object.prototype.cornerSize = 24;        // desktop corner size
// fabric.Object.prototype.touchCornerSize = 32;
    function deleteObject(eventData, transform) {
      const target = transform.target;
      console.log("target.customId",target);
      // remove_items_onjsoin(target.customId.split('_')[2]);
      canvas.remove(target);
      canvas.requestRenderAll();
    }

    // Render delete icon exactly as requested
    function renderDeleteIcon(ctx, left, top, styleOverride, fabricObject) {
      const size = 20;
      const img = document.createElement('img');
      img.src = deleteIconImg.src;

      img.onload = function () {
        ctx.drawImage(img, left - 10, top - 10, size, size);
      };
      // Attempt to draw anyway in case it's cached
      ctx.drawImage(img, left - 10, top - 10, size, size);
    }


    function setBackgroundFromURL(element) {
      const url = element.getAttribute('data-image');
          element.closest('[data-main-popup]').classList.add('hidden');
    
          if (!url) return;
          var center = canvas.getCenter();
    
          fabric.Image.fromURL(url, function(img) {
            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
              scaleX:0.9,
              scaleY:1,
              top: center.top,
              left: center.left,
              originX: 'center',
              originY: 'center',
              crossOrigin: 'anonymous'
            });
             saveState();
          }, { crossOrigin: 'anonymous' });
             
        }


         function setBackgroundFromURLSRC(url){
          if (!url) return;
          console.log("url",url);
          canvas.clear();
          var center = canvas.getCenter();
    
          fabric.Image.fromURL(url, function(img) {
            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
              scaleX:0.9,
              scaleY:1,
              top: center.top,
              left: center.left,
              originX: 'center',
              originY: 'center',
              crossOrigin: 'anonymous'
            });
          }, { crossOrigin: 'anonymous' });
              saveState();
        }


          function UploadImageFilds(event) {
            const file = event.target.files[0];
            if (!file) return;
              const reader = new FileReader();
                reader.onload = function (f) {
                  const url = f.target.result;
          
                  fabric.Image.fromURL(url, function (img) {
                    img.scaleToWidth(300);
                    img.set({ left: 100, top: 100, selectable: false });
          
                    // Group image and text together
                    const group = new fabric.Group([img], {
                      left: img.left,
                      top: img.top,
                      subTargetCheck: true
                    });
                    canvas.add(group);
                    canvas.setActiveObject(group);
                    currentGroup = group;
                  }, { crossOrigin: 'anonymous' });
                };
                reader.readAsDataURL(file);          
          }


          function showTextModal(text,fontFamily, group) {
            const text_selector= document.getElementById('popup-text') || null
            const check_button = text_selector.closest('.tool-item') || null;
            if(check_button && !check_button.classList.contains('active')){
              console.log("check_button",check_button);
                  check_button.querySelector('button').click();
            }
                // check_button.classList.add('active');
                text_selector.value = text;
                currentGroup = group;
            }
        function hideTextModal() {          
              document.getElementById('popup-text').value = '';
          document.getElementById('popup-qr-code').value = '';
              currentGroup = null;
            }


          // function updateLiveText(event) {
          //     const uniqueId = `var_${Date.now()}`;
          //         const textVal = event.target.value;
          //         const font = "Arial";
          //         if (currentGroup) {
          //           const textObj = currentGroup._objects.find(o => o.type === 'textbox');
          //            if (textObj) {
          //             textObj.set({
          //               text: textVal || textObj.text,
          //               fontFamily: font
          //             });
          //               canvas.requestRenderAll();
          //            }
          //         } else {
          //           // Create new group with image + text
          //             const text = new fabric.Textbox(textVal, {
          //               fontSize: 20,
          //               fontFamily: font,
          //               fill: '#000',
          //               textAlign: 'center',
          //               width: 150
          //             });
                    
          //           const group = new fabric.Group([text], {
          //             left: 100,
          //             top: 200,
          //             subTargetCheck: true
          //           });
              
          //              group.customId = uniqueId;
          //              currentGroup = group;
          //              canvas.add(group);
          //              canvas.setActiveObject(group);
          //              canvas.requestRenderAll();
          //         }
          //   }


          function updateLiveText(event) {
                const uniqueId = `var_${Date.now()}`;
                const textVal = event.target.value;
                const font = "Arial";

                function resizeTextbox(textObj) {
                    const ctx = canvas.getContext();
                    ctx.font = `${textObj.fontSize}px ${textObj.fontFamily}`;

                    const newWidth = ctx.measureText(textObj.text).width + 20;

                    textObj.set({
                        width: newWidth
                    });

                    // handle Fabric 4 and 5
                    if (textObj.initDimensions) textObj.initDimensions();
                    if (textObj._initDimensions) textObj._initDimensions();
                }

                // UPDATE EXISTING GROUP
                if (currentGroup) {
                    const textObj = currentGroup._objects.find(o => o.type === 'textbox');

                    if (textObj) {
                        textObj.set({
                            text: textVal,
                            fontFamily: font,
                            textBaseline: 'alphabetic' // FIXED VALUE
                        });

                        resizeTextbox(textObj);

                        // SAFE FABRIC UPDATE
                        currentGroup.addWithUpdate();
                        canvas.requestRenderAll();
                        saveState();
                        return;
                    }
                }

                // CREATE NEW TEXTBOX
                const text = new fabric.Textbox(textVal, {
                    fontSize: 20,
                    fontFamily: font,
                    fill: '#000',
                    textAlign: 'center',
                    width: 150,
                    textBaseline: 'alphabetic'
                });

                resizeTextbox(text);

                const group = new fabric.Group([text], {
                    left: 100,
                    top: 200,
                    subTargetCheck: true
                });

                group.customId = uniqueId;
                currentGroup = group;

                canvas.add(group);
                canvas.setActiveObject(group);
                canvas.requestRenderAll();
                saveState();
            }



            // function addQR(event) {
            //   const qrText = event.target.closest('.edit-form').querySelector('input').value;
            //   const qrSize = 250;
            //   const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(qrText)}&size=${qrSize}x${qrSize}`;
            //   const uniqueId = `var_${Date.now()}`;
            
            //   // Load QR image asynchronously
            //   fabric.Image.fromURL(qrApiUrl, function (qrImg) {
            //     if (!qrImg) {
            //       console.error("Failed to load QR image.");
            //       return;
            //     }
            
            //     qrImg.set({
            //       left: 0,
            //       top: 0,
            //       scaleX: 1,
            //       scaleY: 1,
            //       selectable: true,
            //       customType:'qr',
            //       qrText: qrText,
            //       qrColor: '#000000'
            //     });
            
            //     // Wrap in a group if needed (allows future extensibility)
            //     const group = new fabric.Group([qrImg], {
            //       left: 100,
            //       top: 200,
            //       subTargetCheck: true
            //     });
            
            //     group.customId = uniqueId;
            //     currentGroup = group;
            
            //     canvas.add(group);
            //     canvas.setActiveObject(group);
            //     canvas.requestRenderAll();
            //     saveState();
            //   }, { crossOrigin: 'anonymous' });
            // }







                        // Function to wait for the QR image src to exist
                                  function waitForQRUrl(timeout = 5000, interval = 100) {
                                    return new Promise((resolve, reject) => {
                                      const start = Date.now();

                                      const check = () => {
                                        const imgEl = document.getElementById("qrcode")?.querySelector('img');
                                        const qrApiUrl = imgEl?.getAttribute('src');

                                        if (qrApiUrl) {
                                          resolve(qrApiUrl);
                                        } else if (Date.now() - start > timeout) {
                                          reject(new Error("QR code URL not found within timeout"));
                                        } else {
                                          setTimeout(check, interval);
                                        }
                                      };

                                      check();
                                    });
                                  }


                            async function addQR(event) {
                                  const qrText = event.target
                                    .closest('.edit-form')
                                    .querySelector('input').value;

                                  const uniqueId = `qr_${Date.now()}`;

                                  try {
                                    // Wait for QR code to be ready

                                     var qrcode = new QRCode(document.getElementById("qrcode"), {
                                        width : 250,
                                        height : 250,
                                    });

                                    qrcode.makeCode(qrText);

                                    const qrApiUrl = await waitForQRUrl();
                                    console.log("QR URL found:", qrApiUrl);
                                    document.getElementById("qrcode").innerHTML = '';

                                    // Create Fabric.js image
                                    fabric.Image.fromURL(qrApiUrl, function (qrImg) {
                                      if (!qrImg) return;

                                      qrImg.set({
                                        left: 0,
                                        top: 0,
                                        selectable: true,
                                        customType: 'qr',
                                        qrText: qrText,
                                        qrColor: '#000000'
                                      });

                                      const group = new fabric.Group([qrImg], {
                                        left: 100,
                                        top: 200,
                                        subTargetCheck: true
                                      });

                                      group.customId = uniqueId;
                                      currentGroup = group;

                                      canvas.add(group);
                                      canvas.setActiveObject(group);
                                      canvas.requestRenderAll();
                                      saveState();
                                    }, { crossOrigin: 'anonymous' });

                                  } catch (err) {
                                    console.error(err.message);
                                  }
                                }


                                    // async function addQR(event) {
                                    //     const qrText = event.target
                                    //         .closest('.edit-form')
                                    //         .querySelector('input').value;

                                    //     const uniqueId = `qr_${Date.now()}`;

                                    //     // Function to wait for QR SVG to be rendered in the container
                                    //     function waitForQRSVG(timeout = 5000, interval = 50) {
                                    //         return new Promise((resolve, reject) => {
                                    //             const start = Date.now();

                                    //             const check = () => {
                                    //                 const svgEl = document.getElementById("qrcode")?.querySelector('svg');
                                    //                 if (svgEl) {
                                    //                     resolve(svgEl);
                                    //                 } else if (Date.now() - start > timeout) {
                                    //                     reject(new Error("QR SVG not generated within timeout"));
                                    //                 } else {
                                    //                     setTimeout(check, interval);
                                    //                 }
                                    //             };

                                    //             check();
                                    //         });
                                    //     }

                                    //     try {
                                    //         // Generate QR code as SVG inside the container
                                    //         const qrcode = new QRCode(document.getElementById("qrcode"), {
                                    //            width : 100,
	                                  //            height : 100
                                    //         });
                                    //         qrcode.makeCode(qrText);

                                    //         // Wait until SVG element exists
                                    //         const svgEl = await waitForQRSVG();

                                    //         // Serialize SVG to string
                                    //         const serializer = new XMLSerializer();
                                    //         const svgString = serializer.serializeToString(svgEl);

                                    //         // Encode SVG string as Data URI
                                    //         const svgDataUri = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
                                    //         console.log("QR SVG Data URI:", svgDataUri);

                                    //         // Create Fabric image from SVG Data URI
                                    //         fabric.Image.fromURL(svgDataUri, function (qrImg) {
                                    //             if (!qrImg) return;

                                    //             qrImg.set({
                                    //                 left: 0,
                                    //                 top: 0,
                                    //                 selectable: true,
                                    //                 customType: 'qr',
                                    //                 qrText: qrText,
                                    //                 qrColor: '#000000'
                                    //             });

                                    //             const group = new fabric.Group([qrImg], {
                                    //                 left: 100,
                                    //                 top: 200,
                                    //                 subTargetCheck: true
                                    //             });

                                    //             group.customId = uniqueId;
                                    //             currentGroup = group;

                                    //             canvas.add(group);
                                    //             canvas.setActiveObject(group);
                                    //             canvas.requestRenderAll();
                                    //             saveState();
                                    //         }, { crossOrigin: 'anonymous' });

                                    //     } catch (err) {
                                    //         console.error("QR SVG not added:", err.message);
                                    //     }
                                    // }







               async function regenerateQR(qrObj, text, color) {
                      const size = 250;

                      // const qrApiUrl =
                      //   `https://api.qrserver.com/v1/create-qr-code/?` +
                      //   `data=${encodeURIComponent(text)}` +
                      //   `&size=${size}x${size}` +
                      //   `&color=${color.replace('#', '')}`;

                         var qrcode = new QRCode(document.getElementById("qrcode"), {
                                        width : 250,
                                        height : 250,
                                        colorDark :color
                                    });

                                    console.log("qrcode",qrcode);

                                    qrcode.makeCode(text);
                      const qrApiUrl = await waitForQRUrl();
                                    console.log("QR URL found:", qrApiUrl);
                        document.getElementById("qrcode").innerHTML = ''

                      fabric.Image.fromURL(qrApiUrl, function (newImg) {
                        if (!newImg) return;

                        newImg.set({
                          left: qrObj.left,
                          top: qrObj.top,
                          scaleX: qrObj.scaleX,
                          scaleY: qrObj.scaleY,
                          angle: qrObj.angle,
                          customType: 'qr',
                          qrText: text,
                          qrColor: color
                        });

                        const group = currentGroup;
                        const index = group._objects.indexOf(qrObj);

                        group._objects[index] = newImg;
                         currentGroup = group;
                        group.addWithUpdate();

                        canvas.requestRenderAll();
                        saveState();
                      }, { crossOrigin: 'anonymous' });
                    }





                function showQRModal(qrText, group) {
                  currentGroup = group;
                  const qrInput = document.getElementById('popup-qr-code');
                  qrInput.value = qrText;
                }



             function uploadImageFromURL(url) {
                      const uniqueId = `var_${Date.now()}`;
                    fabric.Image.fromURL(url, function (img) {
                      img.scaleToWidth(50);
                      img.set({
                        left: 100,
                        top: 150
                      });                
                          // Group image and text together
                          const group = new fabric.Group([img], {
                            left: img.left,
                            top: img.top,
                            subTargetCheck: true
                          });
                           group.customId = uniqueId;
                           canvas.add(group);
                           canvas.setActiveObject(group);
                           currentGroup = group; 
                      console.log("group");
                    }, { crossOrigin: 'anonymous' });
             }

                    function setTextAlign(align) {
                      const textObj = currentGroup._objects.find(o => o.type === 'textbox');
                      if (textObj) {
                        textObj.set('textAlign', align);
                        canvas.requestRenderAll();
                        saveState();
                      }
                    }
                    
                    function toggleStyle(style) {

                       const textObj = currentGroup._objects.find(o => o.type === 'textbox');
                      if (!textObj) return;
                    
                      const current = textObj[style === 'bold' ? 'fontWeight' : 'fontStyle'];
                      const value = current === style ? 'normal' : style;
                    
                      if (style === 'bold') {
                        textObj.set('fontWeight', value);
                      } else if (style === 'italic') {
                        textObj.set('fontStyle', value);
                      }
                    
                      canvas.requestRenderAll();
                      saveState();
                    }

                    function toggleDecoration(decoration) {
                      const textObj = currentGroup?._objects.find(o => o.type === 'textbox');
                      if (!textObj) return;
                      switch (decoration) {
                        case 'underline':
                        case 'linethrough':
                        case 'overline':
                          const current = textObj[decoration] || false;
                          textObj.set(decoration, !current);
                          break;
                        default:
                          console.warn(`Unsupported decoration: ${decoration}`);
                          return;
                      }
                      textObj.dirty = true;
                      canvas.requestRenderAll();
                      saveState();
                    }


                    function changeTextColor(color) {
                        const textObj = currentGroup?._objects.find(o => o.type === 'textbox');
                      if (!textObj) return;
                       textObj.set('fill', color);
                       canvas.requestRenderAll();
                       saveState();
                    }



                   async  function changeqrColor(color) {
                    console.log("currentGroup",currentGroup)
                      if (!currentGroup) return;
                      const qrObj = currentGroup._objects.find(
                        o => o.customType === 'qr'
                      );

                      console.log("qrObj",qrObj);

                      if (!qrObj || !qrObj.qrText) return;
                      regenerateQR(qrObj, qrObj.qrText, color);
                    }





                  function fontFamilyChange(fontFamily) {
                        const textObj = currentGroup?._objects.find(o => o.type === 'textbox');
                        if (!textObj) return;
                        textObj.set('fontFamily', fontFamily);
                        canvas.requestRenderAll();
                        saveState();
                      }



                      // cropm function start
                      


                  function cropImage() {
                    const obj = canvas.getActiveObject();
                    if (!obj || obj.type !== 'group') return;
                    const img = obj._objects.find(o => o.type === 'image');
                    console.log("img",img)
                    if (!img) return;
                    img.set({ cropX: 20, cropY: 20, width: img.width - 40, height: img.height - 40 });
                    canvas.requestRenderAll();
                    saveState();
                  }



                  function enableCropMode(btn) {
                    const obj = canvas.getActiveObject();
                    if (!obj || obj.type !== 'group') {
                        alert("Please select a group that contains an image.");
                        return;
                    }

                    currentGroup = obj;
                    selectedImage = obj._objects.find(o => o.type === 'image');

                    if (!selectedImage) {
                        alert("No image found inside this group.");
                        return;
                    }

                    document.querySelector('#applay_crop_btn')?.classList.remove('hidden');
                    btn.classList.add('hidden');

                    isCropping = true;
                    canvas.discardActiveObject();
                    canvas.selection = false;

                    console.log("Crop mode ON → Image inside group:", selectedImage);
                }



                  function applyCrop(this_) {
                        if (!isCropping || !selectedImage || !cropRect || !currentGroup) return;
                        document.querySelector('#applay_crop_btn')?.classList.add('hidden');
                         this_.classList.remove('hidden');

                        const rect = cropRect.getBoundingRect();
                        const imgRect = selectedImage.getBoundingRect();

                        // Calculate crop offsets relative to image
                        const cropX = rect.left - imgRect.left;
                        const cropY = rect.top - imgRect.top;
                        const cropSize = rect.width;

                        // Apply cropping on internal image
                        selectedImage.set({
                            cropX: cropX,
                            cropY: cropY,
                            width: cropSize / selectedImage.scaleX,
                            height: cropSize / selectedImage.scaleY
                        });

                        // Recalculate inside group
                        selectedImage.setCoords();
                        currentGroup._calcBounds();
                        currentGroup._updateObjectsCoords();
                        currentGroup.setCoords();

                        // Cleanup
                        canvas.remove(cropRect);
                        cropRect = null;
                        isCropping = false;

                        canvas.selection = true;
                        canvas.setActiveObject(currentGroup);
                        canvas.requestRenderAll();
                        saveState();
                        console.log("Crop applied & group updated!");
                    }
                  

                   let colorInterval = null;

                      function toggleColorFilterWithCycle() {
                        const obj = canvas.getActiveObject();
                        if (!obj || obj.type !== 'group') return;
                      
                        const img = obj._objects.find(o => o.type === 'image');
                        if (!img) return;
                      
                        if (colorInterval) {
                          clearInterval(colorInterval);
                          colorInterval = null;
                          // Remove BlendColor filter
                          img.filters = img.filters.filter(f => f.type !== 'BlendColor');
                          img.applyFilters();
                          canvas.requestRenderAll();
                          saveState();
                          return;
                        }
                      
                        let hue = 0;
                        colorInterval = setInterval(() => {
                          hue = (hue + 10) % 360;
                          const color = `hsl(${hue}, 100%, 50%)`;
                      
                          // Use BlendColor instead of Tint
                          const blendFilter = new fabric.Image.filters.BlendColor({
                            color: color,
                            mode: 'tint',
                            alpha: 0.5
                          });
                      
                          // Remove existing BlendColor filters and apply new one
                          img.filters = img.filters.filter(f => f.type !== 'BlendColor');
                          img.filters.push(blendFilter);
                          img.applyFilters();
                          canvas.requestRenderAll();
                          saveState();
                        }, 300);
                      }




                  function adjustOpacity() {
                    const obj = canvas.getActiveObject();
                    if (!obj || obj.type !== 'group') return;
                    const img = obj._objects.find(o => o.type === 'image');
                    if (!img) return;
                     const levels = [1, 0.7, 0.4, 0.1];
                    const current = img.opacity || 1;
                    const nextIndex = (levels.indexOf(current) + 1) % levels.length;
                    img.set('opacity', levels[nextIndex]);
                    canvas.requestRenderAll();
                    saveState();
                  }
                  
                  
                  function duplicateImageGroup() {
                    const obj = canvas.getActiveObject();
                    if (!obj || obj.type !== 'group') return;
                    obj.clone(function (cloned) {
                      cloned.set({ left: obj.left + 20, top: obj.top + 20 });
                      canvas.add(cloned);
                      canvas.setActiveObject(cloned);
                      canvas.requestRenderAll();
                      saveState();
                    });
                  }
                 
                  
                  function alignImageGroup() {
                    const obj = canvas.getActiveObject();
                    if (!obj || obj.type !== 'group') return;
                    const alignments = ['left', 'center', 'right'];
                    const alignment = alignments[currentAlignmentIndex];
                    const groupWidth = obj.getScaledWidth?.() || obj.width;
                  
                    if (alignment === 'left') {
                      obj.left = 0;
                    } else if (alignment === 'center') {
                      obj.left = (canvas.width - groupWidth) / 2;
                    } else if (alignment === 'right') {
                      obj.left = canvas.width - groupWidth;
                    }
                  
                    obj.setCoords();
                    canvas.requestRenderAll();
                    saveState();
                  
                    currentAlignmentIndex = (currentAlignmentIndex + 1) % alignments.length;
                  }

                  function rotateImageGroup() {
                      const obj = canvas.getActiveObject();
                      if (!obj || obj.type !== 'group') return;
                    
                      const currentAngle = obj.angle || 0;
                      const newAngle = (currentAngle + 45) % 360; // rotate in steps of 45°
                      
                      obj.rotate(newAngle);
                      obj.setCoords(); // update position after rotation
                      canvas.requestRenderAll();
                      saveState();
                    }
                  
                  
                  function sketchImageGroup() {
                      const obj = canvas.getActiveObject();
                      if (!obj || obj.type !== 'group') return;
                      const img = obj._objects.find(o => o.type === 'image');
                      if (!img) return;
                      // Toggle: if Sepia filter exists, remove it; otherwise, add it
                      const sepiaIndex = img.filters.findIndex(f => f && f.type === 'Sepia');
                      if (sepiaIndex !== -1) {
                        // Remove Sepia filter
                        img.filters.splice(sepiaIndex, 1);
                      } else {
                        // Add Sepia filter (sketch effect simulation)
                        img.filters.push(new fabric.Image.filters.Sepia());
                      }                    
                      img.applyFilters();
                      canvas.requestRenderAll();
                      saveState();
                    }

                  
                  function deleteImageGroup() {
                    const obj = canvas.getActiveObject();
                    if (!obj || obj.type !== 'group') return;
                    canvas.remove(obj);
                    canvas.requestRenderAll();
                    saveState();
                  }


                   function setFrontPrintArea() {
                    alert("Front print area placeholder");
                  }
                  
                  function setBackPrintArea() {
                    alert("Back print area placeholder");
                  }

                  function removeBackgroundPlaceholder() {
                    alert("This requires an external API like remove.bg or PhotoRoom");
                  }


                  // save JSON
                    function saveCanvasJSON(index_id) {

                       if (!window.json_avalable || typeof window.json_avalable !== "object") {
                            window.json_avalable = {};
                          }

                        const savedCanvasJSON = JSON.stringify(canvas.toJSON());

                        console.log("index_id",index_id)

                        window.json_avalable[index_id] = savedCanvasJSON;
                        return savedCanvasJSON;
                        // console.log("Canvas saved JSON:", savedCanvasJSON);
                    }

                    // reload json
                    function json_load(data_json){
                        // canvas.clear();
                    canvas.loadFromJSON(data_json, function() {
                      canvas.renderAll();
                      console.log(" Canvas reloaded successfully from JSON!");
                    });
                  }



                          function saveState() {
                              if (isRestoring) return;

                              const json = JSON.stringify(
                                  canvas.toJSON(['customId']) // keep custom properties
                              );

                              undoStack.push(json);

                              // Clear redo history on new action
                              redoStack = [];

                              // Optional: limit history size
                              if (undoStack.length > 50) {
                                  undoStack.shift();
                              }
                          }




                    function undo() {
                        if (undoStack.length <= 1) return;

                        isRestoring = true;

                        const currentState = undoStack.pop();
                        redoStack.push(currentState);

                        const prevState = undoStack[undoStack.length - 1];

                        canvas.loadFromJSON(prevState, () => {
                            canvas.renderAll();
                            isRestoring = false;
                        });
                    }


                    function redo() {
                        if (!redoStack.length) return;

                        isRestoring = true;

                        const nextState = redoStack.pop();
                        undoStack.push(nextState);

                        canvas.loadFromJSON(nextState, () => {
                            canvas.renderAll();
                            isRestoring = false;
                        });
                    }






              canvas.on('mouse:down', function (opt) {
                if (isCropping){
                      let pointer = canvas.getPointer(opt.e);
                        cropStart = pointer;
                        cropRect = new fabric.Rect({
                            left: pointer.x,
                            top: pointer.y,
                            width: 0,
                            height: 0,
                            fill: "rgba(0,0,0,0.3)",
                            stroke: "red",
                            strokeWidth: 1,
                            selectable: false,
                            evented: false
                        });
                        canvas.add(cropRect);
                    }else{
                          const target = opt.target;
                          hideTextModal();
                          // Hide popup if clicking outside a group
                          if (!target || target.type !== 'group') {
                            hideTextModal();
                            return;
                          }
                          // Otherwise show modal for new group
                          const textObj = target._objects.find(o => o.type === 'textbox');
                          console.log("textObj",textObj);
                          if (textObj) {
                            showTextModal(textObj.text, textObj.fontFamily, target);
                              return
                          }
            
                            const qrImg = target._objects.find(o =>
                            o.type === 'image' &&
                            o.getSrc && o.getSrc().includes('api.qrserver.com') // detect QR code from known URL
                          );
                        
                          if (qrImg) {
                            const qrUrl = qrImg.getSrc();
                            const params = new URLSearchParams(qrUrl.split('?')[1]);
                            const qrData = decodeURIComponent(params.get('data') || '');
                        
                            showQRModal(qrData, target); // Implement this function to edit QR text
                            return;
                          }
                        }
                })



               canvas.on("mouse:move", function (opt) {
              if (!isCropping || !cropRect) return;

              let pointer = canvas.getPointer(opt.e);

              let w = pointer.x - cropStart.x;
              let h = pointer.y - cropStart.y;

              let size = Math.min(Math.abs(w), Math.abs(h)); // square

              cropRect.set({
                  width: size,
                  height: size,
                  left: w < 0 ? cropStart.x - size : cropStart.x,
                  top: h < 0 ? cropStart.y - size : cropStart.y
              });

              canvas.requestRenderAll();
              saveState();
          });



            async function getCanvasImageUrl() {
              const dataUrl = canvas.toDataURL({ format: 'png', multiplier: 2 });
              const blob = dataURLtoBlobGetnew(dataUrl);
            
              const formData = new FormData();
              const filename = `canvas_image_${Date.now()}.png`;
              formData.append('file', blob, filename);
            
              try {
                const response = await fetch("https://arteria.sa/Imageuppload.php", {
                  method: 'POST',
                  body: formData
                });
            
                const result = await response.json(); // assuming your PHP returns { success: true, url: "https://..." }
            
                if (result.success && result.url) {
                  return result.url; // ✅ This is your full uploaded image URL
                } else {
                  console.error('Upload failed:', result.message || result);
                  return null;
                }
              } catch (error) {
                console.error('Upload error:', error);
                return null;
              }
            }


          async function generateFinalDissin() {
            const finalImageUrl = await getCanvasImageUrl(); // async function returning URL

            console.log("finalImageUrl",finalImageUrl)
          
            const finalDissin = {
              _finaldissin: {
                finalimage: {
                  src: finalImageUrl
                }
              }
            };
          
            return finalDissin;
          }


        function dataURLtoBlobGetnew(dataurl) {
          const arr = dataurl.split(',');
          const mime = arr[0].match(/:(.*?);/)[1];
          const bstr = atob(arr[1]);
          let n = bstr.length;
          const u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new Blob([u8arr], { type: mime });
        }


async function getCanvasGroupsJSON() {
  const groupsData = {};
  let groupIndex = 1;

  for (const group of canvas.getObjects('group')) {
    const groupKey = `_group_${groupIndex++}`;

    // Check if QR code group (by customId or single image with QR URL)
    if (group.customId && group.customId.startsWith("var_")) {
      const qrImg = group._objects.find(o => o.type === 'image');
      if (qrImg) {
        let src = qrImg.getSrc();

        // Check if src is base64 data URL
        if (src.startsWith("data:image")) {
          // Await the upload function to get real URL
          src = await file_upload_image64(src);
        }

        groupsData[groupKey] = {
          qrcode: {
            src
          }
        };
        continue;
      }
    }

    const groupInfo = {};

    for (const obj of group._objects) {
      if (obj.type === 'image') {
        let src = obj.getSrc();

        if (src.startsWith("data:image")) {
          src = await file_upload_image64(src);
        }

        groupInfo.image = {
          src
        };
      } else if (obj.type === 'textbox') {
        groupInfo.text = {
          text: obj.text,
          style: {
            fontSize: obj.fontSize,
            fontFamily: obj.fontFamily,
            fill: obj.fill,
            textAlign: obj.textAlign,
            textDecoration: obj.textDecoration || ''
          }
        };
      }
    }

    groupsData[groupKey] = groupInfo;
  }

  console.log(groupsData);
  return groupsData;
}



function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/png'; // default if not found
  const bstr = atob(arr[1]); // base64 decode
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
}



async function file_upload_image64(image_url) {
  const randomNumber = Math.random();
  const base64 = image_url;
  const blob = dataURLtoBlob(base64);

  const formdata = new FormData();
  formdata.append("file", blob, `custom_product_image${randomNumber}.png`);

  const requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow"
  };

  try {
    const response = await fetch("https://arteria.sa/Imageuppload.php", requestOptions);
    const resultText = await response.text();

    // Try parsing resultText to JSON
    const result = JSON.parse(resultText);

    if (result && result.url) {
      return result.url;
    } else {
      console.error("Upload succeeded but no URL found in response:", result);
      return null;
    }

  } catch (error) {
    console.error("Upload failed:", error);
    return null;
  }
}



// canvas.upperCanvasEl.addEventListener('touchstart', function(e) {
//   e.preventDefault();
// }, { passive: false });

// canvas.upperCanvasEl.addEventListener('touchmove', function(e) {
//   e.preventDefault();
// }, { passive: false });




function handlePrintAreaChange(value) {

const selected_varint =  document.querySelector('input[name="selected_product"]')?.value;
if(selected_varint){

  const _selected_varian_meta =  window.variant_prosnolize[selected_varint] || null;
   console.log("_selected_varian_meta",_selected_varian_meta);
      if(_selected_varian_meta){
        if (value === 'Front') {
          window.active_side = 'front';
             window.back_json = saveCanvasJSON(2);
             const _select_var_image =  _selected_varian_meta.image || null;
              canvas.clear();
            if(window.front_json){
              json_load(window.front_json);
            }else{
                if(_select_var_image) setBackgroundFromURLSRC(_select_var_image);
            }
             console.log("window.back_json",window.back_json);
        } else if (value === 'Back') {
          window.active_side = 'back';
              window.front_json = saveCanvasJSON(1);
               const _select_var_image_back =  _selected_varian_meta.back_image || null;
                canvas.clear();
                 if(window.back_json){
                  json_load(window.back_json);
                }else{
                   if(_select_var_image_back) setBackgroundFromURLSRC(_select_var_image_back);
                }
        }
     } 
  }
}



function getActiveSide() {
    return window.active_side === 'back' ? 'back' : 'front';
}